import { Component, EventEmitter, Inject, OnDestroy, Output } from '@angular/core';
import { OverlayHelper } from '../../../../helper/overlay.helper';
import { CONTACTS_DATA_SERVICE, ContactsDataService } from '../../../../services/contacts/contacts-data.service';
import { IContact, LeadDataObject } from '../../../../models/leads/leads.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseCustomDialog } from '../../../shared-module/dialogs/base-custom-dialog';

@Component({
  selector: 'fi-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  standalone: false,
})
export class ErrorComponent extends BaseCustomDialog implements OnDestroy {
  @Output() popupClosed = new EventEmitter<boolean>();

  replaceKeys: boolean = false;
  errorTitle: string = '';
  errorDescription: string = '';

  constructor(
    public dialogRef: MatDialogRef<ErrorComponent>,
    @Inject(CONTACTS_DATA_SERVICE) private contactsDataService: ContactsDataService,
    @Inject(MAT_DIALOG_DATA) public dialogData: { replaceKeys: boolean; errorSnippets: { [key: string]: string } },
  ) {
    super(dialogRef);
    if ( dialogData ) {
      this.replaceKeys = !!dialogData.replaceKeys;
      this.errorTitle = dialogData.errorSnippets.title;
      this.errorDescription = dialogData.errorSnippets.description;
    }
  }

  ngOnDestroy(): void {
    OverlayHelper.unfixBody();
  }

  closeDialog( closedOnSuccess: boolean ): void {
    this.popupClosed.emit(closedOnSuccess);
    this.clearClassAndCloseDialog(this.dialogRef);
    this.dialogRef.close(true);
  }

  onClosePopup(): void {
    this.closeDialog(false);
  }

  onOverlayClick( event: Event ): void {

    if ( event.target === event.currentTarget ) {
      this.onClosePopup();
    }
  }
}
